import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import PapWorkplace from 'components/organisms/pap-workplace';

import s from './styles.module.scss';

const AdminPapWorkplacePage = () => {
  return (
    <div className={s.wrapper}>
      <PapWorkplace />
      <ScrollToTopButton />
    </div>
  );
};

export default AdminPapWorkplacePage;
